module.exports = __webpack_public_path__ + "img/bike.05c640f4.png";